import { useCallback, useEffect, useState } from "react";
import type { ProxyCallResult } from "../types";
import { fetchBootstrap } from "../api/accountProxy";

export function useAccountBootstrap({
  shopDomain,
  proxyBase = "/apps/paws",
}: {
  shopDomain: string | null;
  proxyBase?: string;
}) {
  const [loading, setLoading] = useState(true);
  const [bootstrapError, setBootstrapError] = useState<string | null>(null);
  const [bootstrap, setBootstrap] = useState<any>(null);
  const [proxyLog, setProxyLog] = useState<ProxyCallResult[]>([]);

  const runAndLog = useCallback(
    async (runner: () => Promise<ProxyCallResult>) => {
      const r = await runner();
      setProxyLog((prev) => [r, ...prev].slice(0, 8));
      return r;
    },
    []
  );

  const refresh = useCallback(async () => {
    if (!shopDomain) {
      setBootstrapError("Missing shopDomain");
      setLoading(false);
      return;
    }

    setLoading(true);
    setBootstrapError(null);

    const r = await runAndLog(() => fetchBootstrap(proxyBase, shopDomain));

    if (!r.ok) {
      setBootstrapError(r.error || `Bootstrap failed (${r.status})`);
      setBootstrap(null);
      setLoading(false);
      return;
    }

    setBootstrap(r.body);
    setLoading(false);
  }, [proxyBase, runAndLog, shopDomain]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return {
    loading,
    bootstrapError,
    bootstrap,
    setBootstrap,
    proxyLog,
    refresh,
    effectiveShop: shopDomain || "",
    effectiveProxyBase: proxyBase,
  };
}
